import React, { Component, useEffect, useMemo, useState } from 'react';
import { FormStore } from './FormStore';
import { FormContext } from './FormContext';
import { classnames } from '../../lib';
import { useForm } from './hooks/useForm';
import { FormField } from './FormField';
import { FormFieldArray } from './FormFieldArray';
import { FormGroup } from './FormGroup';
import { FormSection } from './FormSection';
const getNewStore = (props) => {
    return new FormStore(props.initialValues);
};
const FormContent = ({ className, children, onSubmit, resetOnUnmount, initialValues, disableValidation }) => {
    const { handleSubmit, subscribeToSubmit, reset, store } = useForm();
    useEffect(() => {
        const unsubscribe = subscribeToSubmit((...args) => {
            if (onSubmit)
                onSubmit(...args);
        });
        return () => {
            unsubscribe();
        };
    }, [onSubmit]);
    useEffect(() => {
        return () => {
            if (resetOnUnmount) {
                reset();
            }
        };
    }, []);
    useEffect(() => {
        store.setState(state => (Object.assign(Object.assign({}, state), { disableValidation })));
    }, [disableValidation]);
    useMemo(() => {
        if (initialValues) {
            store.initialState = Object.assign(Object.assign({}, store.initialState), { values: initialValues });
            store.setState(state => (Object.assign(Object.assign({}, state), { values: initialValues })));
        }
    }, [initialValues]);
    return (React.createElement("form", { className: classnames('form', className), onSubmit: handleSubmit }, children));
};
const FormProvider = props => {
    const store = useMemo(() => {
        return props.store || getNewStore(props);
    }, []);
    const [str, setStr] = useState({});
    useEffect(() => {
        return store.subscribe(() => {
            setStr({});
        });
    }, []);
    return (React.createElement(FormContext.Provider, { value: { fire: str, store } },
        React.createElement(FormContent, Object.assign({}, props))));
};
let Form = /** @class */ (() => {
    class Form extends Component {
        render() {
            return React.createElement(FormProvider, Object.assign({}, this.props));
        }
    }
    Form.Field = FormField;
    Form.FieldArray = FormFieldArray;
    Form.ContextConsumer = FormContext.Provider;
    Form.Group = FormGroup;
    Form.Section = FormSection;
    return Form;
})();
export { Form };
//# sourceMappingURL=Form.js.map